import { useEffect } from 'react'

/**
 * Modale di conferma riusabile, in sostituzione di window.confirm().
 * Lo stile riprende quello già usato nella conferma di uscita sessione,
 * così tutte le richieste di conferma dell'app hanno lo stesso aspetto.
 *
 * Uso tipico:
 *   const [conferma, setConferma] = useState(null)
 *   ...
 *   setConferma({ testo: 'Rimuovere questo membro?', onConferma: () => rimuovi(id) })
 *   ...
 *   {conferma && <ModaleConferma {...conferma} onAnnulla={() => setConferma(null)} />}
 */
export default function ModaleConferma({
  titolo = 'Confermi?',
  testo,
  icona = '⚠️',
  testoConferma = 'Conferma',
  testoAnnulla = 'Annulla',
  distruttiva = false,
  onConferma,
  onAnnulla,
}) {
  // Esc chiude, come ci si aspetta da una finestra di dialogo.
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onAnnulla && onAnnulla() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onAnnulla])

  return (
    <div
      onClick={onAnnulla}
      style={{
        position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      }}
      className="fade-in"
    >
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 360 }}>
        <div style={{ background: 'var(--surface)', borderRadius: 20, padding: 28, border: '1px solid var(--border)' }}>
          <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 16 }}>{icona}</div>
          <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 18, textAlign: 'center', marginBottom: 10 }}>
            {titolo}
          </div>
          {testo && (
            <div style={{ fontSize: 14, color: 'var(--muted)', textAlign: 'center', lineHeight: 1.7, marginBottom: 24 }}>
              {testo}
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button
              className={distruttiva ? 'btn btn-secondary' : 'btn btn-primary'}
              onClick={onConferma}
              style={distruttiva
                ? { fontSize: 15, color: 'var(--red)', borderColor: 'rgba(255,90,90,0.4)' }
                : { fontSize: 15 }}
            >
              {testoConferma}
            </button>
            <button className="btn btn-ghost" onClick={onAnnulla} style={{ fontSize: 14, color: 'var(--muted)' }}>
              {testoAnnulla}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
